import CustomWidgetView from './CustomWidgetView.vue';

export const type = 'customWidget';
export const view = CustomWidgetView;

export function builder() {
  return {
    type,
    left: 0,
    top: 0,
    rotate: 0,
    height: 100,
    width: 350,
    textAlign: 'right',
    verticalAlign: 'start',
  };
}
